var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sfcConditionNodeContainer",
      class: { vertical: _vm.vertical },
    },
    [
      !_vm.readonly
        ? _c(
            "div",
            {
              staticClass: "sfcConditionAddBtn",
              on: { click: _vm.onAddConditionBranchClick },
            },
            [_vm._v(" 添加条件 ")]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "sfcConditionNodeItemList" },
        _vm._l(_vm.data.children, function (node) {
          return _c(
            "div",
            { key: node.id, staticClass: "sfcConditionNodeItem" },
            [
              _c("div", {
                staticClass:
                  "sfcConditionNodeItemLine sfcConditionNodeItemFirstLine",
              }),
              _c("div", {
                staticClass:
                  "sfcConditionNodeItemLine sfcConditionNodeItemLastLine",
              }),
              _c("div", { staticClass: "sfcConditionNodeItemLinkLine" }),
              _c(
                "div",
                { staticClass: "sfcConditionNodeItemNodeWrap" },
                [
                  _c("SFCNode", {
                    attrs: {
                      nodeList: null,
                      childrenList: _vm.data.children,
                      data: node,
                      belongConditionNodeData: _vm.data,
                      isMouseEnter: _vm.isMouseEnter,
                    },
                  }),
                  _c("div", {
                    staticClass: "sfcConditionNodeItemLinkCrossLine",
                  }),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _c("SFCArrowLine", { attrs: { data: _vm.data } }),
      _c("SFCAddNode", {
        attrs: {
          nodeList: _vm.nodeList,
          nodeData: _vm.data,
          btnType: _vm.isMouseEnter ? "dot" : "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }